/**
 * Create a chain of promises that execute serially.
 *
 * While this implementation is based off the following articles, after some
 * discussion with some trusted peers in the JavaScript community, we agreed
 * that an async/await for..of loop was easier to understand.
 *
 * See also:
 *
 * *  https://stackoverflow.com/questions/24586110/resolve-promises-one-after-another-i-e-in-sequence
 * *  https://hackernoon.com/functional-javascript-resolving-promises-sequentially-7aac18c4431e
 * *  https://css-tricks.com/why-using-reduce-to-sequentially-resolve-promises-works/
 */
export const promiseSerial = async (tasks) => {
    const results = [];
    for (const task of tasks) {
        results.push(await task());
    }
    return results;
};
